export default __webpack_public_path__ + "static/media/logo.d41d77f3.png";